module.exports = __webpack_public_path__ + "img/icon-info.afe35cce.svg";